/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://cihost.uberflip.com/providenceV2/master/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.recoEnginePositioning = recoEnginePositioning;
/**
 * Loop over each tile, and if the tag specified (1st param) is present, execute yesTagFn (2nd param)
 * if the tag is not present, execute noTagFn (3rd param). In both callbacks, **this** reffers to the tile currently being
 * checked
 *
 * @param {string} filterBy --> The tag to look for
 * @param {function} [yesTagFn=function() {}] --> The function to run if a tile has the desired tag.
 * @param {function} [noTagFn=function() {}] --> The function to run if a tile does NOT have the desired tag.
 * @param {string} OPTIONAL: A css class to ignore, and to add after the tile has been processed.
 * @returns {boolean} --> returns true if the front end tags are enabled, otherwise returns false and logs an error.
 */
exports.doIfTag = function (filterBy) {
	var yesTagFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	var noTagFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
	var not = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

	if ($('body').hasClass('include_fe_item_tags')) {
		$('.tile').not(not).each(function (i, el) {
			//Get the tags for this tile.
			var allTagsString = el.dataset.tags;

			//assume it doesn't have the tag we want
			var hasTag = false;

			//If there is any tags to even check...
			if (allTagsString) {
				//split the tags into an array
				var allTagsArray = allTagsString.split(',');

				//loop over the array
				allTagsArray.forEach(function (tag) {
					//if the tag matches what we're looking for, change hasTag to true
					if (tag.toLowerCase() === filterBy.toLowerCase()) {
						hasTag = true;
					}
				});
			}
			//Do this if the tile has the tag
			if (hasTag) {
				yesTagFn.call(this);
				//Do this if the tile doesn't...
				$(this).addClass(not);
				return true;
			} else {
				noTagFn.call(this);
				$(this).addClass(not);
				return true;
			}
		});
	} else {
		console.error('-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-');
		console.error('  Onbrander: You called doIfTag, but front end tags are NOT enabled !');
		console.error('-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-');
		return false;
	}
};

/**
 * Take the hub share window, rip it out, and make our own. On page change, replace our new share window with the appropriate one
 * for that page. Applies event listeners for load and page change, simply call near the begining of your code.
 *
 * @returns {function} --> The function that updates on page change.
 */
exports.fixShareWidgetImproved = function () {
	$('head').append('<style id="shareWidgetFix">\n\t.relativeDiv {\n\t\tposition: relative;\n\t\tfloat: right;\n\t\t}\n\t\t\n\t\t.relativeDiv.relativeDiv--search {\n\t\tfloat: left;\n\t\t}\n\t\t\n\t\t.relativeDiv--share:hover .share-hub {\n\t\tdisplay: block;\n\t\t}\n\t\t\n\t\t.share-hub,\n\t\t.share-item {\n\t\tmargin: auto;\n\t\t}\n\t\t\n\t\t.search-drop-down {\n\t\tposition: absolute;\n\t\t}\n\t\t\n\t\t@media all and (min-width: 860px) {\n\t\t.share-hub,\n\t\t.share-item {\n\t\tright: auto;\n\t\tposition: absolute;\n\t\tleft: -450% !important;\n\t\ttop: 51px !important;\n\t\t}\n\t\t.search-drop-down {\n\t\tright: 0;\n\t\tposition: absolute;\n\t\tleft: -4% !important;\n\t\ttop: 55px !important;\n\t\t}\n\t\t}\n\t\t\n\t\t@media all and (max-width: 860px) {\n\t\t.share-hub,\n\t\t.share-item {\n\t\tright: auto;\n\t\tposition: absolute;\n\t\tleft: -576% !important;\n\t\ttop: 45px !important;\n\t\t}\n\t\t}\n\t\t\n\t\t@media all and (max-width: 720px) {\n\t\t.share-hub,\n\t\t.share-item {\n\t\tright: auto;\n\t\tposition: absolute;\n\t\tleft: -465% !important;\n\t\ttop: 45px !important;\n\t\t}\n\t\t}\n\t</style>');
	//rip out share window, put inside of relative div (in the same place)
	//create div to house elements
	$('.right-side-btns').prepend('<div class="relativeDiv relativeDiv--share"><div class="insertFlag--share"></div></div>');
	//rip share-main and place after the flag div
	$('#share-main-hub').clone().insertAfter('.insertFlag--share');
	$('.share-toggle').insertAfter('.insertFlag--share');

	//do the same to search box
	$('.right-side-btns').prepend('<div class="relativeDiv relativeDiv--search"><div class="insertFlag--search"></div></div>');
	$('.search-drop-down').insertAfter('.insertFlag--search');
	$('.search-container').insertAfter('.insertFlag--search');
	//This function will update the share widget for different pages
	var $shareMain = $('#share-main-hub');
	var update = function update() {
		if ($('.meta-inner .share-container').length) {
			$('.right-side-btns .share-hub').remove();
			$('.right-side-btns .share-container').remove();
			$('.meta-inner .share-container').insertAfter('.insertFlag--share');
		} else if ($('.share-item.type-collection').length && !$('body').hasClass('hub-page')) {
			$('.right-side-btns .share-hub').remove();
			$('.right-side-btns .share-container').remove();
			$('#hubs-container .page-aligner>.share-container').insertAfter('.insertFlag--share');
		} else {
			$('.right-side-btns .share-hub').remove();
			$('.right-side-btns .share-container').remove();
			if ($('#share-main-hub').length) {
				$('#share-main-hub').clone().insertAfter('.insertFlag--share');
			} else {
				$shareMain.clone().insertAfter('.insertFlag--share');
			}
		}
	};
	// Make sure social still opens in popup
	var links = document.querySelectorAll('#share-main-hub li a');
	links.forEach(function (link) {
		return link.addEventListener('click', function (e) {
			e.preventDefault();
			window.open(this.href, 'windowName', 'width=540, height=433, left=24, top=24, scrollbars, resizable');
		});
	});
	Hubs.Events.on('load', update);
	Hubs.Events.on('pageChange', update);
	return update;
};

/**
 * This function is to be called on scroll, and will keep the block CTAs within the bounds of the article they are
 * supposed to be blocking (preventing them from overlapping the injected header and footer).
 */
exports.blockCtaFix = function () {
	var $blockCta = $('.block-cta:not(.embed-cta)');

	if ($blockCta.length && !$('.level-three .block-cta').length) {
		var $main = $('.main');
		var ctaHalfHeight = $blockCta.height() / 2;
		var top = $main.offset().top;
		var bottom = $main.offset().top + $main.height();
		var bottomFromBottom = $(document).height() - bottom;
		var middleScreen = $(window).scrollTop() + $(window).height() / 2;

		var middleScreenTop = middleScreen - ctaHalfHeight;
		var middleScreenBottom = middleScreen + ctaHalfHeight;
		// console.log(middleScreenTop)
		if (middleScreenTop < top) {
			$blockCta.css({
				position: 'absolute',
				top: top,
				bottom: '',
				transform: 'translate(-50%, -50%)',
				margin: 0
			});
		} else if (middleScreenBottom > bottom) {
			$blockCta.css({
				position: 'absolute',
				top: bottom - $blockCta.height() - ctaHalfHeight,
				transform: 'translate(-50%, -50%)',
				margin: 0
			});
		} else {
			$blockCta.css({
				position: 'fixed',
				top: '50vh',
				bottom: '',
				transform: 'translate(-50%, -50%)',
				margin: 0
			});
		}
	}
};

/**
 * When called on scroll, this function will fade out the next-item-flyout before it can overlap with the
 * injected-footer
 */
exports.fadeOutItem = function () {
	if ($('body').hasClass('single-page')) {
		var footerHeight = $('footer').height();
		var pageHeight = document.body.scrollHeight - $(window).height();
		var sweetSpot = pageHeight - (footerHeight + $(window).height());
		if ($(window).scrollTop() > sweetSpot) {
			$('.item-next-prev').fadeOut('fast');
		} else {
			$('.item-next-prev').fadeIn('fast');
		}
	}
};

/**
 * Simply adds the css required to have tile descriptions slide up on hover
 */
exports.descriptionSlideUp = function () {
	$('head').append('<style id="descriptionsSlideUp">\n\t/*-- Tile Description Pop-up Hover --*/\n\t#collection-items .tile .description {\n\t\t-webkit-transition: all 0.4s ease-out;\n\t\ttransition: all 0.4s ease-out;\n\t}\n\t#collection-items .tile .description .long-h3 {\n\t\tdisplay: block !important;\n\t}\n\t\n\t#collection-items .tile:hover .description {\n\t\theight: 100%;\n\t\t-webkit-transition: all 0.3s ease-out;\n\t\ttransition: all 0.3s ease-out;\n\t}\n\t\n\t#collection-items .tile .share-single {\n\t\tdisplay: none;\n\t}\n\t</style>');
};

exports.devMode = function (devOptions) {
	console.log(' ');
	console.log(' ');
	console.warn('-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=');
	console.warn("   Hey Onbrander, Just letting you know that we're in dev mode!");
	console.warn('   You have access to the following functions:', exports);
	console.warn('   More info available here: http://cihost.uberflip.com/docs/');
	console.warn('-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=');
	console.log(' ');
	console.log(' ');

	/**
  *  Utility Functions
  */
	var _internalLink = function _internalLink(e) {
		e.preventDefault();
		Hubs.changePage(e.target.href);
	};

	/**
  *
  * @param {string} url - the url to replace with a relative path
  */
	var _relativeLinks = function _relativeLinks(url) {
		//We need relative links for local dev, so we regex for the url as the href
		var matchThis = new RegExp('^((http[s]?|ftp):/)?/?([^:/s]+)?(' + url + ')', 'gi');
		$('a').not('.onBrand--LocalDevLink').each(function (index, el) {
			var testThis = $(this).attr('href');
			if (matchThis.test(testThis) || testThis && testThis.charAt(0) === '/') {
				var newHref = testThis.replace(matchThis, '');
				if (!(newHref[0] === '/')) {
					newHref = '/' + newHref + '?onbrand';
				} else {
					newHref = newHref + '?onbrand';
				}
				$(this).attr('href', newHref);
				$(this).attr('target', '');
				//add event listener to do internal page change instead of full reload
				$(this).on('click', _internalLink);
				$(this).addClass('onBrand--LocalDevLink');
			}
		});
	};
	/**
  *  Local Development Events
  */

	if (false) {
		//run right away to catch any early clickers out there...
		_relativeLinks(devOptions.shortHubUrl);
		Hubs.Config.hubBaseUrl = 'http://localhost:3000/';

		//run on load to catch any links added via scripts or anything
		Hubs.Events.on('load', function () {
			_relativeLinks(devOptions.shortHubUrl);
			Hubs.Config.hubBaseUrl = 'http://localhost:3000/';
		});
		//run on page change to get links on different pages
		Hubs.Events.on('pageChange', function () {
			_relativeLinks(devOptions.shortHubUrl);
			Hubs.Config.hubBaseUrl = 'http://localhost:3000/';
		});
		//get all the links on extra tiles added in
		Hubs.Events.on('itemsLoaded', function () {
			_relativeLinks(devOptions.shortHubUrl);
		});
		$(window).on('search', function () {
			setTimeout(function () {
				_relativeLinks(devOptions.shortHubUrl);
			}, 500);
		});
	}
};

/**
 * Recursivley remove all the standard classes from our topnav clone,
 * add some handly classes in the prcoess. Called as the callback to
 * a jQuery .each(). EX $(parent).children().each(removeClasses)
 *
 * @param {index} i
 * @param {element} el
 */
exports.removeClasses = function removeClasses(i, el) {
	$(el).attr('class', '').children().each(removeClasses);
};

/**
 *
 * @param {Regular Expression} What tag you're looking for
 * @param {function} OPTIONAL: A function to execute if the tile has the tag, THIS = the tile inside the function.
 * @param {function} OPTIONAL: A function to execute if the tile DOES NOT have the tag, THIS = the tile inside the function.
 * @param {string} OPTIONAL: A css class to ignore, and to add after the tile has been processed.
 */
exports.doIfTagRegex = function doIfTagRegex(filterBy) {
	var yesTagFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	var noTagFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
	var not = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

	if (!(filterBy instanceof RegExp)) {
		console.error(filterBy + ' is not a valid regular expression! Please use new RegExp() to generate one!');
		return false;
	} else if ($('body').hasClass('include_fe_item_tags')) {
		$('.tile').not(not).each(function (i, el) {
			//Get the tags for this tile.
			var allTagsString = el.dataset.tags;

			//assume it doesn't have the tag we want
			var hasTag = false;
			var theTag;
			//If there is any tags to even check...
			if (allTagsString) {
				//split the tags into an array
				var allTagsArray = allTagsString.split(',');

				//loop over the array
				allTagsArray.forEach(function (tag) {
					//if the tag matches what we're looking for, change hasTag to true
					if (filterBy.test(tag)) {
						hasTag = true;
						theTag = tag;
					}
				});
			}
			//Do this if the tile has the tag
			if (hasTag) {
				yesTagFn.call(this, theTag);
				//Do this if the tile doesn't...
				$(this).addClass(not);
				return true;
			} else {
				noTagFn.call(this);
				$(this).addClass(not);
				return true;
			}
		});
	} else {
		console.error('-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-');
		console.error('  Onbrander: You called doIfTag, but front end tags are NOT enabled !');
		console.error('-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-');
		return false;
	}
};

exports.noQueryStringSafeguard = function () {
	if (/localhost:3000/gi.test(window.location.host) && !(/\?onbrand/gi.test(window.location.href) || /\&onbrand/gi.test(window.location.href))) {
		console.error("It looks like you are in dev mode, but you're missing the onbrand query string.");
	}
};

/**
 * Returns the stream class for that page.
 *
 * @returns {String} 'stream-xxxxx' or false, if the page has no stream.
 */
exports.getStreamClass = function () {
	var classes = $('body').attr('class');
	var classArray = classes.split(' ');
	var streamClass = void 0;
	classArray.forEach(function (currentClass) {
		return (/stream-/gi.test(currentClass) ? streamClass = currentClass : null
		);
	});
	return streamClass ? streamClass : false;
};

/**
 * Adds helpful body classes based on content type to make styling easier.
 */
exports.helpfulClasses = function () {
	//An array to keep track of what content types are used (ensures we are dynamic, no hardcoded types)
	var typeArray = [];

	//the function to run on page change/load

	/**
  * Removes all known type classes from the body, then adds whichever
  * is relevent to that page. Checks to see if that class is known, and if
  * not, adds it to the array.
  */
	function detectAndAddClass() {
		typeArray.forEach(function (type) {
			return $('body').removeClass(type);
		});

		var $class = $('#page-type-identifier').attr('data-item-type');
		if ($class) {
			$('body').addClass($class);
			if (typeArray.indexOf($class) < 0) {
				typeArray.push($class);
			}
		}

		if (!$('body').hasClass('webpackBuild')) {
			$('body').addClass('webpackBuild');
		}
	}

	//Event listeners
	Hubs.Events.on('load', detectAndAddClass);
	Hubs.Events.on('pageChange', detectAndAddClass);
};

/**
 * Locks the reco engine panel to the bottom of the provided target, but moves it to the top of the screen
 * when the target is out of view. 
 * 
 * @param {Selector} target 
 */
function recoEnginePositioning(target) {
	var reposition = function (target) {
		try {
			var $reco = $('.reco-panel');
			var bottomOfTarget = $(target).offset().top + $(target).height();
			var calculatedPosition = bottomOfTarget - $(window).scrollTop();
			var desiredPosition = calculatedPosition > 0 ? calculatedPosition : 0;
			$reco.css('top', desiredPosition);
		} catch (err) {
			console.warn('recoEnginePositioning() has failed - the error thrown was:');
			console.error(err);
			console.warn('The target used was:' + target);
		}
	}.bind($('.reco-panel'), target);

	Hubs.Events.on('scroll', reposition);
	Hubs.Events.on('load', reposition);
	Hubs.Events.on('pageChange', reposition);
	Hubs.Events.on('resize', reposition);
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/phs-white.png";

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/stjosephwhite.png";

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/covenanthealth-white-trans.png";

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/faceymflogo.png";

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/hoagwhite.png";

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/kadlec-white.png";

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/swedish-white.png";

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/pmc-white.png";

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// -- Imports -- //
var onbrandFunctions = __webpack_require__(0);
var devOptions = __webpack_require__(10); //Development options
var onbrand_scss = __webpack_require__(11); //Onbrand styles
var client_scss = __webpack_require__(12); //client styles
var htmlHeader = __webpack_require__(13);
var htmlFooter = __webpack_require__(15);
var onbrandUtilities = __webpack_require__(16); //helper functions for dev
// -- Startup -- //
 true ? null : onbrandUtilities(devOptions);
$('body').prepend(htmlHeader);
$('body').append(htmlFooter);
window.onbrandLoaded = false;
onbrandFunctions.fixShareWidgetImproved();

//For conditional display of article rating system... leave me here.
var $starWidget = $('#starWidget');

// -- Custom Functions -- //

window.onbrand.addBanner = function (settings) {
  var defaults = {
    stream: 'noStreamSelected',
    youtubeVideoLink: 'https://www.google.ca',
    headingText: 'input your heading here!',
    backgroundImage: false,
    buttonColor: false,
    buttonHoverColor: false
  };
  var finalSettings = _extends(defaults, settings);

  if ($('body').hasClass(finalSettings.stream)) {
    $('#bannerVideoLink').attr('href', finalSettings.youtubeVideoLink);
    $('#bannerVideoHeading').html(finalSettings.headingText);
    if ((finalSettings.buttonColor || finalSettings.buttonHoverColor || finalSettings.backgroundImage) && $('#' + finalSettings.stream + '-bannerStyles').length === 0) {
      $('head').append('<style id="' + finalSettings.stream + '-bannerStyles">body.' + finalSettings.stream + ' .heroVideoContainer .heroText button, body.' + finalSettings.stream + ' .heroVideoContainer .heroText button:before, body.' + finalSettings.stream + ' .heroVideoContainer .heroText button:after {background: ' + finalSettings.buttonColor + ' !important;} body.' + finalSettings.stream + ' .heroVideoContainer .heroText button:hover, body.' + finalSettings.stream + ' .heroVideoContainer .heroText button:hover:before, body.' + finalSettings.stream + ' .heroVideoContainer .heroText button:hover:after {background: ' + finalSettings.buttonHoverColor + ' !important;}  ' + (finalSettings.backgroundImage ? 'body.' + finalSettings.stream + ' .heroVideoContainer .videoOverlay { background-image: url("' + finalSettings.backgroundImage + '") !important; } ' : '') + '</style>');
    }
  }
};

window.onbrand.initBanners = function () {
  buildVideo();
  window.onbrand.banners.forEach(function (bannerSetting) {
    window.onbrand.addBanner(bannerSetting);
    Hubs.Events.on('pageChange', window.onbrand.addBanner.bind(this, bannerSetting));
  });
};

//Deprecated, use initBanners
var swapVideoForStream = function swapVideoForStream() {
  if ($('body').hasClass('stream-885062')) {
    $('#bannerVideoLink').attr('href', 'https://www.youtube.com/watch?v=4lrqfx555CI&feature=youtu.be ');
    $('#bannerVideoHeading').html('The Future of <span class="brand2">Digital Health</span>');
  } else if ($('body').hasClass('stream-1009665')) {
    $('#bannerVideoLink').attr('href', '');
    $('#bannerVideoHeading').html('CONNECT WITH US ON LINKEDIN, TWITTER AND FACEBOOK');
  } else if ($('body').hasClass('stream-1050790')) {
    $('#bannerVideoLink').attr('href', 'https://www.youtube.com/watch?v=_lPQsoxPGm8&feature=youtu.be');
    $('#bannerVideoHeading').html('THE FUTURE OF WHOLE PERSON CARE ');
  } else {
    $('#bannerVideoLink').attr('href', '//youtu.be/947THL4EOXE');
    $('#bannerVideoHeading').html('The Future Of Mental Health');
  }
};

var buildVideo = function buildVideo() {
  console.log('building video...');
  var $hero = $('<section class="heroVideoContainer"></section>');
  // $hero.append('<video src="#"></video>');
  $hero.append('<div class="videoOverlay"></div>');
  $hero.append('<div class="heroText"><h1 id="bannerVideoHeading">The Future Of Mental Health</h1><a id="bannerVideoLink" href="//youtu.be/947THL4EOXE" data-lity><button>Play Video <i class="fa fa-play-circle"></i></button></a> </div>');
  $hero.append('<i id="heroArrow" class="fa fa-angle-down"></i>');
  $hero.insertAfter('.top-nav');

  $('#heroArrow').on('click', function (event) {
    event.preventDefault();
    /* Act on the event */
    $('html').animate({ scrollTop: $('.tile:first-of-type').offset().top - 10 + 'px' }, 600);
  });
  // swapVideoForStream();
  // Hubs.Events.on('pageChange', swapVideoForStream);
};

var highResImages = function highResImages(tile) {
  var $highResTile = $(tile).not('.tile[data-id="377063308"]').not('.tile[data-id="378984445"]').children('.img').children('img');
  if ($highResTile.length) {
    var check = $highResTile.attr('src').split('url=')[1];
    var partialDecode = decodeURIComponent($highResTile.attr('src').split('url=')[1]);
    if (!check) {
      return;
    }
    var lastLayer = partialDecode.split('url=')[1];
    if (lastLayer === undefined) {
      $highResTile.attr('src', partialDecode.split('&')[0]);
    } else {
      console.log('else');
      var newSRC = decodeURIComponent(lastLayer).split('&')[0];
      $highResTile.attr('src', newSRC);
    }
  }
};

var customBlogTiles = function customBlogTiles() {
  //Rod's blog
  $('.tile').each(function (index, el) {
    var tags;
    var that = this;
    if ($(this).attr('data-tags')) {
      tags = $(this).attr('data-tags').split(',');
      tags.forEach(function (tag) {
        if (tag.toLowerCase() === 'rod') {
          highResImages(that);
          $(that).addClass('customBlogTile');
          // $(that).find('.view.item-link').text('Read Post') - No longer wanted
          // var $descriptionText = $(that).find('.description h4');
          // var fullDesc = $descriptionText.text();
          // var shortDesc = fullDesc.split(' ').slice(0,9).join(' ') + '...';
          // $descriptionText.text(shortDesc);
          $;
        }
      });
    }
  });
};
var addFATriangles = function addFATriangles() {
  $('.tile.single>a.view').each(function (index, el) {
    if ($(this).children('span.fa.fa-chevron-right').length === 0) {
      var currentText = $(this).text();
      $(this).html('<span class="currentText" >' + currentText + '</span> <span class="fa fa-chevron-right"></span>');
    }
  });
};
var buildQuoteCTA = function buildQuoteCTA() {
  var $cta = $('#hub-cta-81763');
  if ($cta.length) {
    var ctaText = $cta.children('p').text().split('-');
    var quoteText = ctaText[0].trim().slice(1);
    quoteText = '<span class="quoteIcon">\u201C</span>' + quoteText;
    var quoteAuthor = ctaText[1].trim();
    var quoteAuthorSub = ctaText[2].trim();

    $cta.children('p').html(quoteText);
    var $quoteAuthor = $('<p class="quoteAuthor"></p>');
    $quoteAuthor.text(quoteAuthor);
    $quoteAuthor.html($quoteAuthor.html() + '<br><span class="authorSub">' + quoteAuthorSub + '</span>');
    $cta.append($quoteAuthor);
  }
};

//Add special text based on tags
var inTheNewsFlag = function inTheNewsFlag() {
  // $('.tile').find('a').data('internal', false);
  $('.tile:not(.newsChecked)').not('.cta').each(function (index, el) {
    var target = $(this).children('a').data();
    if (target) {
      var hasTag = false;
      if ($(this).attr('data-tags')) {
        var tags = $(this).attr('data-tags').split(',');
        tags.forEach(function (tag) {
          if (tag.toLowerCase() === 'in the news') {
            hasTag = true;
          }
        });
      }

      if (!target.internal || hasTag) {
        $(this).find('.h3like').html('<span class="inTheNews">In The News <i class="fa fa-external-link"></i><br></span>' + $(this).find('.h3like').html());
        // $(this).children('a').each(function(index, el) {
        //   $(this).attr('target', '_blank').off('click');
        // });
      }
    }
    $(this).addClass('newsChecked');
  });
};

var audioFlag = function audioFlag() {
  // $('.tile').find('a').data('internal', false);
  $('.tile:not(.audioChecked)').not('.cta').each(function (index, el) {
    var hasTag = false;
    if ($(this).attr('data-tags')) {
      var tags = $(this).attr('data-tags').split(',');
      tags.forEach(function (tag) {
        if (tag.toLowerCase() === 'audio clip') {
          hasTag = true;
        }
      });
    }

    if (hasTag) {
      $(this).find('.h3like').html('<span class="inTheNews">Audio Clip <i class="fa fa-volume-up "></i><br></span>' + $(this).find('.h3like').html());
      // $(this).children('a').each(function(index, el) {
      //   $(this).attr('target', '_blank').off('click');
      // });
    }
    $(this).addClass('audioChecked');
  });
};

var videoFlag = function videoFlag() {
  // $('.tile').find('a').data('internal', false);
  $('.tile:not(.videoChecked)').not('.cta').each(function (index, el) {
    var hasTag = false;
    if ($(this).attr('data-tags')) {
      var tags = $(this).attr('data-tags').split(',');
      tags.forEach(function (tag) {
        if (tag.toLowerCase() === 'watch video') {
          hasTag = true;
        }
      });
    }

    if (hasTag) {
      $(this).find('.h3like').html('<span class="inTheNews">Watch Video <i style="font-size: 15px;" class="fa fa-play-circle "></i><br></span>' + $(this).find('.h3like').html());
      // $(this).children('a').each(function(index, el) {
      //   $(this).attr('target', '_blank').off('click');
      // });
    }
    $(this).addClass('videoChecked');
  });
};

var starWidgetItemLevel = function starWidgetItemLevel() {
  if ($('body').hasClass('single-page')) {
    $starWidget.remove();
    $('.entry-wrapper').append($starWidget);
  } else {
    $('body').append($starWidget);
  }
};

var nextItemFlyoutNewTab = function nextItemFlyoutNewTab() {
  $('.item-next-prev a').attr({ target: '_blank', 'data-internal': 'false' }).removeClass('hooked').off();
};

//Add special text based on [External] being in title
var externalLinkTitle = function externalLinkTitle() {
  var testFor = /\[EXTERNAL\]/gi;
  $('.tile').not('.externalLink').each(function (index, el) {
    var $h3 = $(this).find('.description .h3like');
    var testMe = $(this).find('.description .h3like').text();
    if (testFor.test(testMe)) {
      var newText = testMe.replace(testFor, '');
      console.log(newText);
      $(this).find('.description .h3like').text(newText);
      $(this).addClass('externalLink');
      $(this).find('a').attr('target', '_blank').removeClass('hooked').off();
    }
  });
  $('.item-next-prev').each(function (index, el) {
    var $a = $(this).find('a');
    var that = this;
    $a.each(function (index, el) {
      if (testFor.test($(this).attr('data-page-title'))) {
        $(this).text($(this).text().replace(testFor, '')).attr('target', '_blank').removeClass('hooked').off();
        $(this).siblings('.preview').find('.title').text($(this).siblings('.preview').find('.title').text().replace(testFor, ''));
      }
    });
  });
};

var customNavigationHandler = function customNavigationHandler() {
  var topNav = $('.top-nav').clone();
  var parent = '\n    <div id="custom-dropdown" class="custom-dropdown">\n      <ul>\n        <li class="dropdown-parent">\n          <span class="dropdown-icon"></span>\n        </li>\n      </ul>\n    <div>\n  ';

  var subMenu = topNav.find('.left-nav').attr('class', 'dropdown-submenu').clone();

  subMenu.find('li').removeClass().find('a').removeClass();

  var share = topNav.find('.relativeDiv--share').clone();

  if ($('body').hasClass('stream-2437559') && $('body #custom-dropdown').length === 0) {
    $('#injected-header header .top.grid:not(.chart)').append(parent);
    $('#injected-header .dropdown-parent').append(subMenu);
    $('.custom-dropdown').prepend(share);
  }

  var menuToggle = $('.dropdown-parent');
  var menuOpen = 'menu-open';
  var shareToggle = $('.relativeDiv--share');
  var shareOpen = 'share-open';

  // Wait for share-hub to render, then check and remove it
  setTimeout(function () {
    if ($('#custom-dropdown .share-hub').length > 0) {
      $('#custom-dropdown .share-hub').remove();
    }
  }, 200);

  if ($('#custom-dropdown .share-container').length > 1) {
    $('#custom-dropdown .share-container').not(':first').remove();
  }

  menuToggle.off();
  menuToggle.on('click', function (e) {
    $('body').toggleClass(menuOpen);
  });

  shareToggle.off();
  shareToggle.on('click', function () {
    shareToggle.toggleClass(shareOpen);
  });

  if ($('body').hasClass(menuOpen)) {
    $('body').removeClass(menuOpen);
  }
};

var limitTileDesc = function limitTileDesc() {
  var elem = $('body');
  var length = 15;
  var trailingDots = '...';

  if (elem.hasClass('listing-page') && elem.hasClass('stream-2437559')) {
    var tile = $('.tile:first-of-type');
    var descElem = tile.find('.long-h3');
    var oldDesc = descElem.text().split(' ');

    var newDesc = oldDesc.slice(0, length).map(function (word) {
      return word;
    }).join(' ') + trailingDots;

    descElem.text(newDesc);
  }
};

// OB-1637 

var removeVideoFromAuthorsPage = function removeVideoFromAuthorsPage() {
  var pageIdentifier = document.querySelector('#page-type-identifier');
  var body = document.querySelector('body');
  if (pageIdentifier.dataset.pageType === "PAGE_TYPE_AUTHOR") {
    body.classList.add('author-page');
  }
};

// -- Hub Events -- //
var onLoadAndPageChange = function onLoadAndPageChange() {
  onbrandFunctions.blockCtaFix();
  onbrandFunctions.fadeOutItem();
  starWidgetItemLevel();
  customBlogTiles();
  buildQuoteCTA();
  addFATriangles();
  highResImages('.tile:first-of-type');
  externalLinkTitle();
  inTheNewsFlag();
  audioFlag();
  videoFlag();
  customNavigationHandler();
  limitTileDesc();
  removeVideoFromAuthorsPage();
};
Hubs.Events.on('load', function () {
  if (!window.onbrandLoaded) {
    onLoadAndPageChange();
    // fixShareWidget();
    // Add your onloads here...
    window.onbrand.initBanners();
    // end your onloads before here...
    window.onbrandLoaded = true;
  }
}).on('pageChange', function () {
  onLoadAndPageChange();
}).on('itemsLoaded', function (itemIds, selectors) {
  externalLinkTitle();
  inTheNewsFlag();
  audioFlag();
  videoFlag();
}).on('resize', function () {
  // sideCtaFix();
  addThisFix();
}).on('scroll', function () {
  // sideCtaFix();
  addThisFix();
  onbrandFunctions.blockCtaFix();
  onbrandFunctions.fadeOutItem();
}).on('ctaActivate', function (ctaId) {}).on('ctaFormSubmitSuccess', function (ctaId, mappedData, ctaName) {}).on('search', function () {});

//The new hub events can trigger before cihost scripts are loaded. This will ensure your scripts fire no matter what, but not more than once for 'load'.
if (!window.onbrandLoaded) {
  Hubs.Events.trigger('load');
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//npm run dev => Builds dev code
//npm run prod => Builds prod code (previously you changed production: to true)

var hubs = {
  en: 'future.psjhealth.org/health-is-a-human-right'
};

var devOptions = {
  shortHubUrl: hubs.en, //change me to the base url of your hub (no http(s) or www)
  fullHubUrl: 'http://' + hubs.en + '?ufcc_onbrand_local', //exact url to access hub, leave onbrand query string
  cihostFolder: 'providenceV2', //change me to the cihost folder name
  remindMeToGit: true,
  notifyOnBuildSuccess: true //Gives a (slightly annoying?) message whenever a build completes successfully
};

module.exports = devOptions;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div id=injected-header> <header> <section class=\"top grid chart\"> </section> <section class=\"top grid\"> <div id=top_0_pnlLogo class=logo> <a id=top_0_hplLogo href=/ data-whld=tested> <img src=" + __webpack_require__(14) + " vspace=20 class=lo-res alt=\"Providence St. Joseph Health System\"> </a> </div> <section class=\"mobile-menu visible-mobile\"> <div> <a href=# class=nav-btn data-whld=tested></a> </div> </section> </section> </header> </div>";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/providence_new_logo.png";

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div id=injected-footer> <footer> <section class=footer-block> <div class=\"grid top\"> </div> </section> <div class=\"clearfix foot-inner grid\"> <div class=desktop> <section class=grid-half> <div class=grid-half> <div class=footer-copy> <h3></h3> <span class=logos> <a href=http://www.providence.org/ target=_blank data-whld=tested><img alt=PHS-white width=164 src=" + __webpack_require__(1) + "></a> <a href=http://www.stjhs.org/ target=_blank data-whld=tested><img alt=StJosephwhite width=200 src=" + __webpack_require__(2) + "></a> <a href=http://www.covenanthealth.org/ target=_blank data-whld=tested><img alt=Covenant width=200 src=" + __webpack_require__(3) + "></a> <a href=http://facey.com/ target=_blank data-whld=tested><img alt=Facey-white width=123 src=" + __webpack_require__(4) + "></a> <br class=break> <a href=https://www.hoag.org/ target=_blank data-whld=tested><img alt=Hoag width=67 src=" + __webpack_require__(5) + "></a> <a href=http://www.kadlec.org/ target=_blank data-whld=tested><img alt=Kadlec-white width=102 src=" + __webpack_require__(6) + "></a> <a href=http://www.swedish.org/ target=_blank data-whld=tested><img alt=Swedish-white width=118 src=" + __webpack_require__(7) + "></a> <a href=http://www.pacmed.org/ target=_blank data-whld=tested><img alt=PMC-white width=83 src=" + __webpack_require__(8) + "></a> </span> </div> </div> <div class=grid-half> <div class=footer-copy> <h3></h3> </div> </div> <div class=grid-full> <div class=footer-copy> <h3></h3> </div> </div> </section> <section class=grid-half> <div class=\"inner footer-copy\"> <h3></h3> </div> <section class=\"contact footer-copy\"> <h3></h3> </section> </section> </div> <div class=mobile> <div class=\"accordion grid-full ui-accordion ui-widget ui-helper-reset\" role=tablist> <h3 class=\"enabled ui-accordion-header ui-helper-reset ui-state-default ui-accordion-header-active ui-state-active ui-corner-top ui-accordion-icons\" role=tab id=ui-accordion-1-header-0 aria-controls=ui-accordion-1-panel-0 aria-selected=true aria-expanded=true tabindex=0><span class=\"ui-accordion-header-icon ui-icon ui-icon-triangle-1-s\"></span></h3> <div class=\"accordian_copy ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom ui-accordion-content-active\" id=ui-accordion-1-panel-0 aria-labelledby=ui-accordion-1-header-0 role=tabpanel aria-hidden=false style=\"\"> <span class=logos> <a href=http://www.providence.org/ target=_blank data-whld=tested><img alt=PHS-white width=164 src=" + __webpack_require__(1) + "></a> <a href=http://www.stjhs.org/ target=_blank data-whld=tested><img alt=StJosephwhite width=200 src=" + __webpack_require__(2) + "></a> <a href=http://www.covenanthealth.org/ target=_blank data-whld=tested><img alt=Covenant width=200 src=" + __webpack_require__(3) + "></a> <a href=http://facey.com/ target=_blank data-whld=tested><img alt=Facey-white width=123 src=" + __webpack_require__(4) + "></a> <br class=break> <a href=https://www.hoag.org/ target=_blank data-whld=tested><img alt=Hoag width=67 src=" + __webpack_require__(5) + "></a> <a href=http://www.kadlec.org/ target=_blank data-whld=tested><img alt=Kadlec-white width=102 src=" + __webpack_require__(6) + "></a> <a href=http://www.swedish.org/ target=_blank data-whld=tested><img alt=Swedish-white width=118 src=" + __webpack_require__(7) + "></a> <a href=http://www.pacmed.org/ target=_blank data-whld=tested><img alt=PMC-white width=83 src=" + __webpack_require__(8) + "></a> </span> </div> <h3 class=\"enabled ui-accordion-header ui-helper-reset ui-state-default ui-corner-all ui-accordion-icons\" role=tab id=ui-accordion-1-header-1 aria-controls=ui-accordion-1-panel-1 aria-selected=false aria-expanded=false tabindex=-1><span class=\"ui-accordion-header-icon ui-icon ui-icon-triangle-1-e\"></span></h3> <div class=\"accordian_copy ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom\" id=ui-accordion-1-panel-1 aria-labelledby=ui-accordion-1-header-1 role=tabpanel aria-hidden=true style=display:none> </div> <h3 class=\"enabled ui-accordion-header ui-helper-reset ui-state-default ui-corner-all ui-accordion-icons\" role=tab id=ui-accordion-1-header-2 aria-controls=ui-accordion-1-panel-2 aria-selected=false aria-expanded=false tabindex=-1><span class=\"ui-accordion-header-icon ui-icon ui-icon-triangle-1-e\"></span></h3> <div class=\"accordian_copy ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom\" id=ui-accordion-1-panel-2 aria-labelledby=ui-accordion-1-header-2 role=tabpanel aria-hidden=true style=display:none> </div> </div> <section class=grid-1-fourths> <div class=inner> <section class=contact> </section> </div> </section> </div> <div class=clear></div> </div> <section class=footer-block> <div class=\"grid foot-note\"> <div class=grid-3-fourths> </div> <div class=\"grid-1-fourths social\"> </div> <section class=\"grid-full disclaimer\"> <span>©2017 Providence St. Joseph Health. All Rights Reserved.</span> <div class=footer-info> <a href=http://www2.providence.org/pages/privacyterms.htm target=_blank data-whld=tested>Terms of Use &amp; Privacy Policy </a> <span class=pipe>|</span> <a href=http://www2.providence.org/pages/disclaimer.htm target=_blank data-whld=tested>Disclaimer </a> <span class=pipe>|</span> <a href=http://www.providence.org/Utility-Pages/PHS-nondiscrimination-statement target=_blank data-whld=tested>Notice of Nondiscrimination &amp; Accessibility Rights </a> </div> </section> </div> </section> </footer> </div>";

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var onbrandFunctions = __webpack_require__(0);

module.exports = function (devOptions) {
  console.log(' ');
  console.log(' ');
  console.warn('-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=');
  console.warn("   Hey Onbrander, Just letting you know that we're in dev mode!");
  console.warn('   You have access to the following functions:', onbrandFunctions);
  console.warn('   More info available here: http://cihost.uberflip.com/docs/');
  console.warn('-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=');
  console.log(' ');
  console.log(' ');

  /** 
   *  Utility Functions
   */
  var _internalLink = function _internalLink(e) {
    e.preventDefault();
    Hubs.changePage(e.target.href);
  };

  /**
   * 
   * @param {string} url - the url to replace with a relative path
   */
  var _relativeLinks = function _relativeLinks(url) {
    //We need relative links for local dev, so we regex for the url as the href
    var matchThis = new RegExp('^((http[s]?|ftp):/)?/?([^:/s]+)?(' + url + ')', 'gi');
    $('a').not('.onBrand--LocalDevLink').each(function (index, el) {
      var testThis = $(this).attr('href');
      if (matchThis.test(testThis) || testThis && testThis.charAt(0) === '/') {
        var newHref = testThis.replace(matchThis, '');
        if (!(newHref[0] === '/')) {
          newHref = '/' + newHref + '?onbrand';
        } else {
          newHref = newHref + '?onbrand';
        }
        $(this).attr('href', newHref);
        $(this).attr('target', '');
        //add event listener to do internal page change instead of full reload
        $(this).on('click', _internalLink);
        $(this).addClass('onBrand--LocalDevLink');
      }
    });
  };
  /** 
   *  Local Development Events
   */

  if (false) {
    //run right away to catch any early clickers out there...
    _relativeLinks(devOptions.shortHubUrl);
    Hubs.Config.hubBaseUrl = 'http://localhost:3000/';

    //run on load to catch any links added via scripts or anything
    Hubs.Events.on('load', function () {
      _relativeLinks(devOptions.shortHubUrl);
      Hubs.Config.hubBaseUrl = 'http://localhost:3000/';
    });
    //run on page change to get links on different pages
    Hubs.Events.on('pageChange', function () {
      _relativeLinks(devOptions.shortHubUrl);
      Hubs.Config.hubBaseUrl = 'http://localhost:3000/';
    });
    //get all the links on extra tiles added in
    Hubs.Events.on('itemsLoaded', function () {
      _relativeLinks(devOptions.shortHubUrl);
    });
    $(window).on('search', function () {
      setTimeout(function () {
        _relativeLinks(devOptions.shortHubUrl);
      }, 500);
    });
  }
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// onbrand.bundle.js